import {IDashboardTab} from 'components/types'
import {
  HomeIcon,
  PhoneIcon,
  AccountIcon,
  ProductIcon,
  DealsIcon,
  InvicesIcon,
  RoleManagementIcon,
  ChatIcon,
  CreditCard,
  FeedbackIcon,
  FinanceApplicationIcon,
  MSAAgreementIcon,
  LAAgreementIcon,
  Bell,
  SalesTaxIcon,
  Users,
  MobilePay,
  Certificates,
  ReportIcon,
  SectorIcon,
  QuestionMarkCircle
} from 'assets/svgs'

export const tabs: IDashboardTab[] = [
  {
    icon: <HomeIcon />,
    path: '/dashboard',
    label: 'Home',
    isSuperAdmin: true,
    isSuperManager: true,
    isMSAAdmin: true
  },
  {
    icon: <Bell />,
    path: '/notifications',
    label: 'Notifications',
    isSuperAdmin: true,
    isSuperManager: true,
    isMSAAdmin: true
  },
  {
    icon: <PhoneIcon />,
    path: '/contacts',
    label: 'Contacts',
    isSuperAdmin: true,
    isSuperManager: true,
    isMSAAdmin: true
  },
  {
    icon: <AccountIcon />,
    path: '/accounts',
    label: 'Accounts',
    isSuperAdmin: true,
    isSuperManager: true,
    isMSAAdmin: true
  },
  {
    icon: <ProductIcon />,
    path: '/equipment',
    label: 'Equipment',
    isSuperAdmin: true,
    isSuperManager: true,
    isMSAAdmin: true
  },
  {
    icon: <ReportIcon />,
    path: '/reports',
    label: 'Equipment Reports',
    isSuperAdmin: true,
    isSuperManager: true,
    isMSAAdmin: true
  },
  {
    icon: <DealsIcon />,
    path: '/deals',
    label: 'Deals',
    isSuperAdmin: true,
    isSuperManager: true,
    isMSAAdmin: false
  },
  {
    icon: <InvicesIcon />,
    path: '/invoices',
    label: 'Invoices',
    isSuperAdmin: true,
    isSuperManager: true,
    isMSAAdmin: false
  },
  {
    icon: <ChatIcon />,
    path: '/chats',
    label: 'Chats',
    isSuperAdmin: true,
    isSuperManager: true,
    isMSAAdmin: true
  },
  {
    icon: <QuestionMarkCircle width={18} height={30} />,
    path: '/public-questions',
    label: 'Public Questions',
    isSuperAdmin: true,
    isSuperManager: false,
    isMSAAdmin: false
  },
  {
    icon: <SalesTaxIcon />,
    path: '/sales-tax',
    label: 'Sales Tax',
    isSuperAdmin: true,
    isSuperManager: true,
    isMSAAdmin: false
  },
  {
    icon: <Users />,
    path: '/taxjar-customers',
    label: 'TaxJar Customers',
    isSuperAdmin: true,
    isSuperManager: true,
    isMSAAdmin: false
  },
  {
    icon: <RoleManagementIcon />,
    path: '/role-management',
    label: 'Role Management',
    isSuperAdmin: true,
    isSuperManager: false,
    isMSAAdmin: false
  },
  {
    icon: <FinanceApplicationIcon />,
    path: '/finance-applications',
    label: 'Finance Applications',
    isSuperAdmin: true,
    isSuperManager: false,
    isMSAAdmin: false
  },
  {
    icon: <Certificates />,
    path: '/tax-exemption-applications',
    label: 'Tax Exemption Applications',
    isSuperAdmin: true,
    isSuperManager: false,
    isMSAAdmin: false
  },
  {
    icon: <CreditCard />,
    path: '/bank-account-info',
    label: 'Bank Account Info',
    isSuperAdmin: true,
    isSuperManager: true,
    isMSAAdmin: false
  },
  {
    icon: <DealsIcon />,
    path: '/categories',
    label: 'Categories',
    isSuperAdmin: true,
    isSuperManager: true,
    isMSAAdmin: false
  },
  {
    icon: <SectorIcon />,
    path: '/sectors',
    label: 'Sectors',
    isSuperAdmin: true,
    isSuperManager: true,
    isMSAAdmin: false
  },
  // {
  //   icon: <SyncIcon />,
  //   path: '/sync',
  //   label: 'Sync',
  //   isSuperAdmin: true,
  //   isSuperManager: false,
  //   isMSAAdmin: false
  // },
  {
    icon: <MSAAgreementIcon />,
    path: '/msa-agreement',
    label: 'MSA Agreements',
    isSuperAdmin: true,
    isSuperManager: false,
    isMSAAdmin: false
  },
  {
    icon: <LAAgreementIcon />,
    path: '/listing-agreement',
    label: 'Listing Agreements',
    isSuperAdmin: true,
    isSuperManager: false,
    isMSAAdmin: false
  },
  {
    icon: <MobilePay />,
    path: '/ach-agreement',
    label: 'ACH Agreements',
    isSuperAdmin: true,
    isSuperManager: false,
    isMSAAdmin: false
  },
  {
    icon: <FeedbackIcon />,
    path: '/feedback',
    label: 'Feedback',
    isSuperAdmin: true,
    isSuperManager: false,
    isMSAAdmin: false
  }
]

const extendedRoutes = [
  {
    path: '/deals/deal-details',
    isSuperAdmin: true,
    isSuperManager: true,
    isMSAAdmin: false
  },
  {
    path: '/finance-applications/finance-application-details',
    isSuperAdmin: true,
    isSuperManager: false,
    isMSAAdmin: false
  },
  {
    path: '/accounts/single-account-details',
    isSuperAdmin: true,
    isSuperManager: true,
    isMSAAdmin: true
  },
  {
    path: '/msa-agreement/agreement-details',
    isSuperAdmin: true,
    isSuperManager: false,
    isMSAAdmin: false
  },
  {
    path: '/listing-agreement/agreement-details',
    isSuperAdmin: true,
    isSuperManager: false,
    isMSAAdmin: false
  },
  {
    path: '/role-management/role-management-details',
    isSuperAdmin: true,
    isSuperManager: false,
    isMSAAdmin: false
  },
  {
    path: '/contacts/single-contact-details',
    isSuperAdmin: true,
    isSuperManager: true,
    isMSAAdmin: true
  },
  {
    path: '/categories/single-category-details',
    isSuperAdmin: true,
    isSuperManager: false,
    isMSAAdmin: false
  },
  {
    path: '/equipment/single-equipment-detail',
    isSuperAdmin: true,
    isSuperManager: true,
    isMSAAdmin: true
  },
  {
    path: '/reports/single-report-detail',
    isSuperAdmin: true,
    isSuperManager: true,
    isMSAAdmin: true
  },
  {
    path: '/invoices/create-invoice',
    isSuperAdmin: true,
    isSuperManager: false,
    isMSAAdmin: false
  },
  {
    path: '/invoices/single-invoice-detail',
    isSuperAdmin: true,
    isSuperManager: true,
    isMSAAdmin: false
  }
]

export const routes = tabs
  .map(({path, isMSAAdmin, isSuperAdmin, isSuperManager}) => ({
    path,
    isMSAAdmin,
    isSuperAdmin,
    isSuperManager
  }))
  .concat(extendedRoutes)
